import { doc, setDoc } from "firebase/firestore";
import { db } from "../../../backend/firebaseConfig";

export async function updateAdviserRegulatoryText(adviserId, regulatoryText) {
  if (!adviserId) {
    throw new Error("adviserId is required");
  }

  const value = typeof regulatoryText === "string" ? regulatoryText : "";

  await setDoc(
    doc(db, "Authorized Members", "Advisers", "Data", adviserId),
    { regulatoryText: value },
    { merge: true },
  );

  return value;
}
